import { render } from "./MoviesGrid.vue?vue&type=template&id=5e4d8e04&ts=true"
import script from "./MoviesGrid.vue?vue&type=script&lang=ts"
export * from "./MoviesGrid.vue?vue&type=script&lang=ts"

import "./MoviesGrid.vue?vue&type=style&index=0&id=5e4d8e04&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__